import React from 'react';
import Sad from './sad.jpg';

type Props = {};

export default function Rejection({}: Props) {
	return (
		<>
			<h1 className="text-5xl font-medium">A może jednak???</h1>
			<img src={Sad} className="w-3/4 mx-auto rounded-lg" />
		</>
	);
}
